import { Component, OnDestroy, OnInit } from '@angular/core';
import { PositionTypesService } from '../services/position-types.service';
import { PositionTypeResource } from 'src/app/client-api.service';
import { Subscription } from 'rxjs';
import { MaintenanceService } from '../../services/maintenance.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TableButton, TableColumn } from 'src/app/shared/tcc-ui/tables';
import { PanelSize } from 'src/app/shared/tcc-ui/simple-panel/models';

@Component({
  selector: 'app-position-types',
  templateUrl: './position-types.component.html',
  styles: [
  ]
})
export class PositionTypesComponent implements OnInit, OnDestroy {

  positionTypes: PositionTypeResource[] | undefined;
  filteredPositionTypes: PositionTypeResource[] | undefined;
  buttons: TableButton<any>[] | undefined;
  columns: TableColumn<PositionTypeResource>[] | undefined;
  panalSize: PanelSize = 'small';
  subscription: Subscription | undefined;
  
  state: 'initializing' | 'loading' | 'ready' | 'saving';

  constructor(private activatedRoute: ActivatedRoute,
              private maintenanceService: MaintenanceService,
              private positionTypesService: PositionTypesService,
              private router: Router) { 
        this.state = 'initializing';
        this.columns = [
          { title: 'Position Type Id', name: 'positionTypeId', hidden: true},
          { title: 'Name', name: 'name' },
          { title: 'Is Service', name: 'isService' },         
        ];
    
        this.buttons = [
          {
            data: 'editPositionType',
            iconClass: 'fas fa-pencil-alt',
            hidden: false,
            buttonClass: 'btn btn-sm px-1 py-0 btn-outline-secondary border-0',
            tooltip: 'Edit Position Type'
          },
          {
            data: 'deletePositionType',
            iconClass: 'fas fa-trash-alt', 
            hidden: false,
            buttonClass: 'btn btn-sm px-1 py-0 btn-outline-secondary border-0',
            tooltip: 'Delete Position Type Record'
          }
        ];
  }

  readonly positionTypes$ = this.positionTypesService.positionTypes$;

  ngOnInit(): void {
    this.state = 'loading';
    this.positionTypesService.setPositionTypes();  
    this.subscription = this.positionTypesService.positionTypes$.subscribe(res => {
      this.positionTypes = res;
      this.filteredPositionTypes = res;
      this.state = 'ready';
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  deletePositionType(id: number) {
    if(confirm('Are you sure you want to delete this Position?')) {
      this.state = 'loading';
      this.positionTypesService.deletePositionType(id)
          .subscribe(
            res => {
              this.positionTypesService.setPositionTypes();
              this.maintenanceService.setMaintenanceComponenetPanelSize('full');    
              this.state = 'ready';
            },
            err => {
              this.state = 'ready';
              alert('Error deleting Application View');
              this.maintenanceService.setMaintenanceComponenetPanelSize('full');    
            }
          );
    }        
  }

  filterPositionTypes(event: any) {
    const value = event.target.value;
    this.state = 'loading';
    this.filteredPositionTypes = this.positionTypes?.filter(a => JSON.stringify(a).toLowerCase().indexOf(value.toLowerCase()) !== -1);
    this.state = 'ready';
  }

  rowClicked(event: any) {    
    if (event.button) {
            if (event.button.data === 'editPositionType') {
        this.maintenanceService.setMaintenanceComponenetPanelSize('small');
        this.openPositionTypeUpsertPanel(event.row?.positionTypeId);
      }
      else if (event.button.data === 'deletePositionType') {
        this.deletePositionType(event.row?.positionTypeId);
        // this.router.navigate(['upsert-application-view/', event.row?.id], { relativeTo: this.activatedRoute });
      }
    }
  }

  openPositionTypeUpsertPanel(positionTypeId: number) {
    // this.maintenanceService.setMaintenanceComponenetPanelSize('large');      
    this.router.navigate(['app-position-types-upsert/', positionTypeId], { relativeTo: this.activatedRoute });
  }
}
